// Module
var code = "<modal :data-id=\"dataId\" :width=\"width\" :maxWidth=\"maxWidth\"> <modal-header @close=\"close\"> <slot name=\"header\"></slot> </modal-header> <slot></slot> </modal> ";
// Exports
export default code;